import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { oneYearAheadISO } from 'src/app/utils/date-utils';
import { FormValidationService } from 'src/app/general-services/validation/form-validation.service';
import { Manco } from '../../manco-to-check-up-on';

@Component({
  selector: 'app-manco-form',
  templateUrl: './manco-form.component.html',
  styleUrls: ['./manco-form.component.scss'],
})
export class MancoFormComponent implements OnInit, OnChanges {
  @Input() theManco?: Manco;
  @Output() formSubmit = new EventEmitter<Manco>();
  @ViewChild('ticketNumberInput') ticketNumberInput!: ElementRef<HTMLInputElement>;

  requiredValidator = Validators.required.bind(null);
  datePickerMax: string = '';

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private formValidationService: FormValidationService
  ) {
    this.form = this.fb.group({
      ticketNumber: ['', [this.requiredValidator, Validators.pattern('^[0-9]*$')]],
      customerNumber: [
        '',
        [
          Validators.maxLength(20), //
          Validators.pattern('^$|^[0-9]{6,8}$'),
        ],
      ],
      caseNumber: ['', [Validators.maxLength(20)]],
      forOrderNumber: ['', [Validators.maxLength(30)]],
      mancoOrderNumber: ['', [Validators.maxLength(30)]],
      note: ['', [Validators.maxLength(255)]],
      returnNumber: ['', [Validators.maxLength(20)]],
      treatmentDate: ['', [this.requiredValidator]],
      checkDate: ['', [this.requiredValidator]],
      booked: [false],
      completed: [false],
      returnReceived: [false],
    });
  }

  ngOnInit(): void {
    this.datePickerMax = oneYearAheadISO();
  }

  ngOnChanges() {
    if (this.theManco) {
      this.form.reset();
      const dataWithDates = {
        ...this.theManco,
        treatmentDate: this.theManco.treatmentDate
          ? formatDate(this.theManco.treatmentDate, 'yyyy-MM-dd', 'nl-NL')
          : '',
        checkDate: this.theManco.checkDate ? formatDate(this.theManco.checkDate, 'yyyy-MM-dd', 'nl-NL') : '',
      };
      this.form.patchValue(dataWithDates);

      // Focus on the ticket number input when the dialog is shown
      this.ticketNumberInput.nativeElement.focus();
    }
  }

  onSubmit() {
    if (this.form.valid && this.theManco) {
      const updatedData: Manco = {
        ...this.theManco,
        ...this.form.value,
      };
      this.formSubmit.emit(updatedData);
    }
  }
  isTouchedAndValid(controlName: string): boolean {
    return this.formValidationService.isTouchedAndValid(this.form, controlName);
  }

  isTouchedAndInvalid(controlName: string): boolean {
    return this.formValidationService.isTouchedAndInvalid(this.form, controlName);
  }

  getValidationClass(controlName: string): string {
    return this.formValidationService.isTouchedAndInvalid(this.form, controlName)
      ? 'is-invalid'
      : this.formValidationService.isTouchedAndValid(this.form, controlName)
        ? 'is-valid'
        : '';
  }
}
